/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncomeDto } from './IncomeDto';
import {
    IncomeDtoFromJSON,
    IncomeDtoFromJSONTyped,
    IncomeDtoToJSON,
    IncomeDtoToJSONTyped,
} from './IncomeDto';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface GuarantorDto
 */
export interface GuarantorDto {
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    firstName: string;
    /**
     * Date calendaire "yyyy-MM-dd" — string de bout en bout, jamais de Date sérialisé
     * @type {string}
     * @memberof GuarantorDto
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    civilityId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuarantorDto
     */
    isGuarantor: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuarantorDto
     */
    employmentStatusId: string;
    /**
     * 
     * @type {Array<IncomeDto>}
     * @memberof GuarantorDto
     */
    incomes: Array<IncomeDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof GuarantorDto
     */
    address?: AddressDto;
}

/**
 * Check if a given object implements the GuarantorDto interface.
 */
export function instanceOfGuarantorDto(value: object): value is GuarantorDto {
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('isGuarantor' in value) || value['isGuarantor'] === undefined) return false;
    if (!('employmentStatusId' in value) || value['employmentStatusId'] === undefined) return false;
    if (!('incomes' in value) || value['incomes'] === undefined) return false;
    return true;
}

export function GuarantorDtoFromJSON(json: any): GuarantorDto {
    return GuarantorDtoFromJSONTyped(json, false);
}

export function GuarantorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuarantorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'birthDate': json['birthDate'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'civilityId': json['civilityId'],
        'isGuarantor': json['isGuarantor'],
        'employmentStatusId': json['employmentStatusId'],
        'incomes': ((json['incomes'] as Array<any>).map(IncomeDtoFromJSON)),
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
    };
}

export function GuarantorDtoToJSON(json: any): GuarantorDto {
    return GuarantorDtoToJSONTyped(json, false);
}

export function GuarantorDtoToJSONTyped(value?: GuarantorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'birthDate': value['birthDate'],
        'phone': value['phone'],
        'email': value['email'],
        'civilityId': value['civilityId'],
        'isGuarantor': value['isGuarantor'],
        'employmentStatusId': value['employmentStatusId'],
        'incomes': ((value['incomes'] as Array<any>).map(IncomeDtoToJSON)),
        'address': AddressDtoToJSON(value['address']),
    };
}

